var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cookie-banner-view'),_c('header-view'),_c('router-view'),_c('widget-sidebar-view'),_c('widget-footer-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }